import getNameInitials from '../../utils/getNameInitials';
import { Avatar, Name, ProfileContainer, SubText } from './ProfileStyles';

function Profile({ text = '', subText = '' }) {
  const name = `${text} ${subText}`;
  const nameInitials = getNameInitials(name || '').slice(0, 2);
  return (
    <ProfileContainer>
      <Avatar>{nameInitials}</Avatar>
      <div>
        <Name>{text}</Name>
        <SubText>{subText}</SubText>
      </div>
    </ProfileContainer>
  );
}

export default Profile;
